import type { Adventure } from '../../types'

// Age 4-5: Take Away Tales - Subtraction Basics
export const subtractionTalesAdventure: Adventure = {
  id: 'take-away-tales',
  title: 'Take Away Tales',
  theme: 'counting',
  targetAge: '4',
  difficulty: 'medium',
  estimatedDuration: 8,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hi friend! I'm Tilly! Today we're learning subtraction - that's when we take things away!",
      duration: 5
    },
    story1: {
      id: 'story-1',
      tillyLine: "I have 7 yummy cookies. Oh no! A friend ate 2 cookies. How many are left?",
      duration: 6,
      background: 'orchard'
    },
    choice1: [
      {
        id: 'take-away',
        label: "Find out!",
        tillyLine: "Taking away means subtracting! 7 minus 2 equals...",
        nextState: 'quiz-1'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'simple-addition', // Using addition type with subtraction logic
      question: '7 - 2 = ?',
      tillyPrompt: 'If I have 7 and take away 2, how many are left?',
      options: [
        { id: '4', label: '4', isCorrect: false },
        { id: '5', label: '5', isCorrect: true },
        { id: '6', label: '6', isCorrect: false }
      ],
      // We'll handle this as subtraction in the component
      num1: 7,
      num2: 2
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Great! Now I see 10 colorful balloons. 3 float away into the sky. How many remain?",
      duration: 5,
      background: 'meadow'
    },
    choice2: [
      {
        id: 'count-balloons',
        label: "Count what's left!",
        tillyLine: "10 minus 3... let's see what's left!",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'simple-addition',
      question: '10 - 3 = ?',
      tillyPrompt: '10 balloons, 3 fly away. How many are left?',
      options: [
        { id: '6', label: '6', isCorrect: false },
        { id: '7', label: '7', isCorrect: true },
        { id: '8', label: '8', isCorrect: false }
      ],
      num1: 10,
      num2: 3
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "You're a subtraction star! Ready for the ultimate take-away? 8 minus 5!",
        duration: 5,
        background: 'math-forest'
      },
      quizzes: [
        {
          id: 'challenge-quiz-1',
          type: 'simple-addition',
          question: '8 - 5 = ?',
          tillyPrompt: 'What is 8 take away 5?',
          options: [
            { id: '2', label: '2', isCorrect: false },
            { id: '3', label: '3', isCorrect: true },
            { id: '4', label: '4', isCorrect: false }
          ],
          num1: 8,
          num2: 5
        } as any
      ]
    },
    reward: {
      tillyLine: "Amazing! You mastered taking away! Here's your Take Away Tales badge!",
      badgeName: 'Take Away Hero',
      badgeIcon: '➖',
      nextPreview: 'Next time, we\'ll mix addition AND subtraction!'
    }
  }
}

// Tilly reactions for subtraction
export const tillySubtractionCorrect = [
  "That's right! You took away perfectly!",
  "Yes! Subtraction superpower!",
  "Correct! You know what's left!",
  "Bingo! Taking away is easy for you!",
  "You got it! Fewer than before!",
  "Perfect subtraction! So smart!",
  "Yes! You found what remains!"
]

export const tillySubtractionWrong = [
  "Not quite! Let's count what's left together!",
  "Almost! Try taking away again!",
  "Good try! Imagine the things disappearing!",
  "That's not it, but subtraction is tricky!",
  "Oops! Count backwards to check!",
  "Not that one! How many are left after taking away?",
  "Keep trying! Taking away takes practice!"
]
